import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";

import JoiningRequestsApplicants from "../../../../../components/Events/Event/Applicants";
import { joiningRequestStatuses } from "../../../../../components/Events/Event/Applicants/constants";
import { getEventRequest } from "../../../../../store/Events/actions";
import { ROUTE_PATHS } from "../../../../../utils/RoutesPaths";

import "../ApplicantsTab/ApplicantsTab.scss";

const ADMIN_V2_STATUSES = [
  joiningRequestStatuses.pending,
  joiningRequestStatuses.joined,
  joiningRequestStatuses.rejected,
  joiningRequestStatuses.removed,
];

const ZONES_EDIT_STEP = 2;

const ApplicantsTabV2 = () => {
  const { id } = useParams();
  const history = useHistory();
  const dispatch = useDispatch();
  const event = useSelector((state) => state.events.event);

  const handleRefreshEvent = () => {
    if (id) {
      dispatch(getEventRequest(id));
    }
  };

  const handleNavigateToZones = () => {
    if (!event?.id) return;

    history.push({
      pathname: ROUTE_PATHS.editEvent.replace(":id", event.id),
      state: { initialStep: ZONES_EDIT_STEP },
    });
  };

  return (
    <JoiningRequestsApplicants
      event={event}
      portalVariant="admin-portal"
      enabledStatuses={ADMIN_V2_STATUSES}
      initialStatus={joiningRequestStatuses.pending}
      onRefreshEvent={handleRefreshEvent}
      onNavigateToZones={handleNavigateToZones}
    />
  );
};

export default ApplicantsTabV2;
